export default __webpack_public_path__ + "static/media/yilma.3cdb4838.jpg";